<script setup lang="ts">
import { OpenAndUpcomingProductModel } from '@/models/open-and-upcoming-product.model';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Props {
  product: OpenAndUpcomingProductModel;
}

const props = defineProps<Props>();

function hasPhaseInDateChanged(): boolean {
  return props.product.productPhaseInDate !== props.product.productInitialPhaseInDate;
}
</script>

<template>
  <div class="product-item">
    <div class="product-fabric-img">
      <img :src="props.product.productImageUrl" />
    </div>
    <div class="product-fabric-text">
      <p class="strong-text">
        {{ props.product.productName }}
      </p>
      <p class="remark-text">{{ props.product.productGender }} {{ props.product.productExternalNumber }}</p>
      <p v-if="hasPhaseInDateChanged()" class="new-date-tag">
        <button class="new-date-button">
          <span>
            {{ t('viewLaunchCalendar.new_date').toUpperCase() }}
          </span>
        </button>
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.product-item {
  display: flex;
  min-width: 280px;
  width: 280px;
  padding: 0;
  align-items: center;
  flex-flow: row;
  padding-bottom: 10px;
}

.new-date-button {
  display: inline-flex;
  width: 80px;
  height: 22px;
  justify-content: center;
  border: none;
  padding: 4.4px 8px;
  border-radius: 18px;
  background-color: var(--primary-button-bg-color);
  color: var(--secondary-text-color);
}

.new-date-button span {
  width: 64px;
  height: 13.2px;
  top: 4.4px;
  left: 8px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.product-fabric-img {
  position: relative;
  display: inline-block;

  img {
    display: block;
    width: 60px;
    margin-left: 0px;
  }
}

.new-date-tag {
  display: flex;
  align-items: center;
  padding-top: 2px;
}

.product-fabric-text {
  p {
    margin: 0;
    text-align: left;
    max-width: 160px;
    padding-left: 10px;
  }

  .strong-text {
    font-weight: 500;
  }

  .remark-text {
    padding-top: 2px;
    font-size: 14px;
    color: var(--primary-text-remark-color);
  }
}
</style>
